var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from "react";
import { FormSettingsContext } from "../../utils";
import copy from "fast-copy";
import { useAppSelector } from "@/hooks/store";
export var Color = function () {
    var _a = useContext(FormSettingsContext), settings = _a.settings, editedSettings = _a.editedSettings;
    var fontOpacity = useAppSelector(function (state) { return state.theme; }).fontOpacity;
    var theme = (fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity.detail_view_fields) || {};
    var _b = useState(""), label = _b[0], setLabel = _b[1];
    var _c = useState(""), border = _c[0], setBorder = _c[1];
    var _d = useState(""), background = _d[0], setBackground = _d[1];
    var current = settings.currentComponent || {};
    var s = current.settings || {};
    var style = s.styles || {};
    var color = style.color || {};
    var resolveColor = function (custom, theme) {
        if (custom !== undefined && custom !== null && custom !== "") {
            return custom;
        }
        if (theme !== undefined && theme !== null && theme !== "") {
            return theme;
        }
        return "";
    };
    var removeLabelColor = function () {
        setLabel("#000");
    };
    var removeBgColor = function () {
        setBackground("transparent");
    };
    var removeBorderColor = function () {
        setBorder("transparent");
    };
    var getSanitizedValue = function () {
        var nullValue = {
            border: "",
            background: "",
            label: "",
        };
        var value = copy(color || nullValue);
        return Array.isArray(value) || typeof value !== "object" ? {} : value;
    };
    var updateFromParams = function () {
        var value = getSanitizedValue();
        var bg = value.background || "";
        var lbl = value.label || "";
        var br = value.border || "";
        setBackground(bg);
        setLabel(lbl);
        setBorder(br);
        /*setBackground(resolveColor(value.background, theme.background_color));
        setLabel(resolveColor(value.label, theme.label_color));
        setBorder(resolveColor(value.border, theme.border_color));*/
    };
    var setSettings = function () {
        var currentC = {};
        currentC = __assign(__assign({}, current), { settings: __assign(__assign({}, s), { styles: __assign(__assign({}, style), { color: { label: label, background: background, border: border } }) }) });
        editedSettings(__assign(__assign({}, settings), { currentComponent: currentC, isDirty: true }));
    };
    var initialized = useRef(false);
    useEffect(function () {
        updateFromParams();
        initialized.current = true;
    }, [settings.selected]);
    useEffect(function () {
        setSettings();
    }, [label, background, border]);
    return (_jsxs(_Fragment, { children: [" ", _jsxs("div", { children: [_jsx("label", __assign({ className: "mb-2" }, { children: "Style de couleur" })), _jsxs("span", __assign({ className: "flex flex-row p-2" }, { children: [_jsx("label", { children: "Label:" }), _jsx("input", { defaultValue: label, value: label, type: "color", onChange: function (e) {
                                    setLabel(e.target.value);
                                } }), label && label !== "" && (_jsx("button", __assign({ title: "Supprimer la couleur du label", onClick: function (v) {
                                    removeLabelColor();
                                } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" }) })) }))), _jsx("label", { children: "Background:" }), _jsx("input", { defaultValue: background, value: background, type: "color", onChange: function (e) {
                                    setBackground(e.target.value);
                                } }), background && background !== "" && (_jsx("button", __assign({ title: "Supprimer la couleur du background", onClick: function (v) {
                                    removeBgColor();
                                } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" }) })) }))), _jsx("label", { children: "Border:" }), _jsx("input", { defaultValue: border, value: border, type: "color", onChange: function (e) {
                                    setBorder(e.target.value);
                                } }), border && border !== "" && (_jsx("button", __assign({ title: "Supprimer la couleur du border", onClick: function (v) {
                                    removeBorderColor();
                                } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" }) })) })))] }))] })] }));
};
